import { z } from 'zod/v4';

export const absoluteTimeRangeSchema = z.object({
  start: z.union([z.date(), z.iso.datetime()]).transform((val) => (typeof val === 'string' ? new Date(val) : val)),
  end: z.union([z.date(), z.iso.datetime()]).transform((val) => (typeof val === 'string' ? new Date(val) : val)),
});

export const queryMetadataSchema = z.any();
